const recentMessagesTimeRange = () => {
  const now = Date.now();
  const fromDate = new Date(now - 26 * 60 * 6e4).toISOString();
  const toDate = new Date(now + 26 * 60 * 6e4).toISOString();
  return { rangetype: "absolute", from: fromDate, to: toDate };
};
export default recentMessagesTimeRange;
